import { render } from "./ThumbsUpDown.vue?vue&type=template&id=ee6f4cbc"
const script = {}

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__